import type { IconComponentBaseProps } from 'components/atoms/Icon/types';

import { defaultTheme } from '@/theme';

type ArrowUpProps = IconComponentBaseProps;

export const ArrowUp = ({
  className,
  width = 16,
  height = 16,
  fill = defaultTheme.mantineColors.gray[7],
}: ArrowUpProps) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_904_14155"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect width="16" height="16" fill={fill} />
      </mask>
      <g mask="url(#mask0_904_14155)">
        <path
          d="M7.9991 5.83976L2.85543 10.9833C2.75721 11.0816 2.63971 11.1302 2.50293 11.1289C2.36615 11.1276 2.24865 11.0778 2.15043 10.9794C2.0521 10.8812 2.00293 10.7637 2.00293 10.6269C2.00293 10.4902 2.0521 10.3727 2.15043 10.2744L7.24143 5.17943C7.3491 5.07176 7.46915 4.99315 7.6016 4.9436C7.73415 4.89404 7.86665 4.86926 7.9991 4.86926C8.13154 4.86926 8.26404 4.89404 8.3966 4.9436C8.52904 4.99315 8.6491 5.07176 8.75676 5.17943L13.8516 10.2744C13.9499 10.3727 13.9984 10.4908 13.9971 10.6289C13.9959 10.7669 13.9461 10.885 13.8478 10.9833C13.7495 11.0816 13.632 11.1308 13.4953 11.1308C13.3585 11.1308 13.241 11.0816 13.1428 10.9833L7.9991 5.83976Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};
